/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../apiConfig";
import { Button } from "react-bootstrap";
import { useEffect } from 'react';

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {
    const isAuthenticated = useIsAuthenticated();
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginRedirect(loginRequest).catch(e => {
            console.log(e);
        });
    }

    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    }

    const SwitchTheme = () => {
        const storedTheme = localStorage.getItem('theme')

        //If there is a stored theme and that value is True, true == dark mode 
        // So switch to light mode
        if (storedTheme && storedTheme === 'dark') {
            document.documentElement.setAttribute('data-bs-theme', 'light')
            localStorage.setItem('theme', 'light')
        } else { //If there is no stored theme or the stored theme is light, switch to dark 
            document.documentElement.setAttribute('data-bs-theme', 'dark')
            localStorage.setItem('theme', 'dark')
        }
    }

    useEffect(() => {
        const storedTheme = localStorage.getItem('theme')

        //If there is a stored theme and that value is dark, switch themes so we go from default to dark
        if (storedTheme && storedTheme === 'dark') {
            document.documentElement.setAttribute('data-bs-theme', 'dark')
        } 
    }, [])


    // window.addEventListener('DOMContentLoaded', () => {{
    //     const storedTheme = localStorage.getItem('theme')

    //     //If there is a stored theme and that value is True, true == dark mdoe
    //     if(storedTheme){
    //         SwitchTheme()
    //     }
    // }})

    return (
        <>
            <Navbar className="navbarStyle">
                <a variant='dark' className="navbar-brand" href="/">
                    Olympus
                </a>
                <div className="collapse navbar-collapse justify-content-end">
                    {<Button bg="secondary" onClick={() => SwitchTheme()} style={{ marginRight: '10px' }} >Switch Theme</Button>}
                    {isAuthenticated ?
                        <Button onClick={() => handleLogout()}>Sign Out</Button> :
                        <Button onClick={() => handleLogin()}>Sign In</Button>
                    }
                </div>
            </Navbar>
            <br />
            {props.children}
        </>
    );
};
